import { z } from 'zod'

export const ConfirmTwoFactorSetupDTO = z.object({
  setup_challenge_id: z.string().uuid(),
  revoke_other_sessions: z.boolean().optional()
})

export type ConfirmTwoFactorSetupDTO = z.infer<typeof ConfirmTwoFactorSetupDTO>

export function mapConfirmTwoFactorSetupToDTO (
  setupChallengeId: string,
  revokeOtherSessions?: boolean
): ConfirmTwoFactorSetupDTO {
  return {
    setup_challenge_id: setupChallengeId,
    revoke_other_sessions: revokeOtherSessions
  }
}
